import React from "react";
import googlePlay from "../../assets/image/google-play.png";
import appStore from "../../assets/image/app-store.png";
import mcafee from "../../assets/image/McAfee.svg";
import "./footer.css";

const Footer = () => {
  return (
    <>
      <footer className="fs-footer pt-5">
        <div className="container">

          <div className="row gy-4">
            <div className="col-lg-2 col-md-4 col-6">
              <h6>About Us</h6>
              <ul>
                <li><a href="#">Overview</a></li>
                <li><a href="#">Global Warehouse</a></li>
                <li><a href="#">Advanced R&D Center</a></li>
                <li><a href="#">Quality Control</a></li>
                <li><a href="#">Compliance Center</a></li>
                <li><a href="#">Test Center</a></li>
                <li><a href="#">Contact Us</a></li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-4 col-6">
              <h6>Service</h6>
              <ul>
                <li><a href="#">Payment Methods</a></li>
                <li><a href="#">Shipping Guide</a></li>
                <li><a href="#">Business Account</a></li>
                <li><a href="#">Net Terms</a></li>
                <li><a href="#">Return Policy</a></li>
                <li><a href="#">Product Warranty</a></li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-4 col-6">
              <h6>Resources</h6>
              <ul>
                <li><a href="#">Documentation</a></li>
                <li><a href="#">Glossary</a></li>
                <li><a href="#">Audio & Video</a></li>
                <li><a href="#">NX Community</a></li>
                <li><a href="/blog">NX Blog</a></li>
                <li><a href="#">Case Studies</a></li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-4 col-6">
              <h6>Support</h6>
              <ul>
                <li><a href="/faq">FAQ & Help Center</a></li>
                <li><a href="#">Solution Consulting</a></li>
                <li><a href="#">WDM Transceiver Stock List</a></li>
                <li><a href="#">Products Verification</a></li>
                <li><a href="#">Track My Order</a></li>
                <li><a href="#">RMA Checklist</a></li>
              </ul>
            </div>

            <div className="col-lg-4">
              <h6>Stay in Touch</h6>

              <form className="d-flex flex-column flex-sm-row gap-2 mb-3">
                <input
                  type="email"
                  className="form-control fs-input"
                  placeholder="Email"
                />
                <button className="btn btn-danger px-4">
                  Subscribe
                </button>
              </form>

              <h6 className="mt-4">Download NX APP</h6>
              <div className="d-flex gap-2 mb-3">
                <img src={googlePlay} height="40" alt="Google Play" />
                <img src={appStore} height="40" alt="App Store" />
              </div>

              <div className="fs-social d-flex flex-wrap gap-2">
                <a href="#"><i className="bi bi-linkedin"></i></a>
                <a href="#"><i className="bi bi-youtube"></i></a>
                <a href="#"><i className="bi bi-facebook"></i></a>
                <a href="#"><i className="bi bi-twitter-x"></i></a>
                <a href="#"><i className="bi bi-instagram"></i></a>
              </div>
            </div>
          </div>

          <div className="row align-items-center mt-4 pt-3">
            <div className="col-md-6">
            <img src={mcafee} height={32} alt="McAfee" />
            </div>
            <div className="col-md-6 text-md-end">
              <select className="form-select w-auto d-inline">
                <option>India / $ USD</option>
                <option>USA / $ USD</option>
                <option>Europe / € EUR</option>
              </select>
            </div>
          </div>

          <div className="row mt-2 py-3 border-top">
            <div className="col small">
             <p>
  <a href="/sitemap">Site Map</a> |
  <a href="/accessibility">Accessibility</a> |
  <a href="/privacyPolicy">Privacy Policy</a> |
  <a href="/cookies-notice">Cookies Notice</a> |
  <a href="/termsAndConditions">Terms &amp; Conditions</a> |
  <a href="/report-vulnerability">Report a Vulnerability</a> |
  <a href="/cookie-settings">Cookie Settings</a>
</p>

              <p>© 2009–2026 NX Optics INC. All Rights Reserved.</p>
            </div>
          </div>

        </div>
      </footer>

      <button id="backToTop">
        <i className="bi bi-arrow-up"></i>
      </button>

      
    </>
  );
};

export default Footer;
